<!-- Confirmation Modal -->
<div class="modal-backdrop fade show" (click)="cancel()"></div>
<div class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="bi bi-exclamation-triangle text-danger me-2"></i>
          {{ title }}
        </h5>
        <button type="button" class="btn-close" (click)="cancel()"></button>
      </div>

      <div class="modal-body">
        <p>{{ message }}</p>
        <div class="card bg-body-tertiary">
          <div class="card-body py-2">
            <strong>{{ report.name || '' }}</strong>
            <br>
            <span class="text-muted small">{{ reports.formatReportDates(report) }}</span>
          </div>
        </div>

        <!-- Delete error message -->
        <div *ngIf="error()" class="alert alert-danger small mt-3 mb-0">
          <i class="bi bi-exclamation-circle me-1"></i>
          {{ error() }}
        </div>

        <p *ngIf="!error()" class="text-danger small mt-3 mb-0">
          <i class="bi bi-exclamation-circle me-1"></i>
          {{ warning }}
        </p>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()" [disabled]="loading()">Cancel</button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="confirm()"
          [disabled]="loading()"
        >
          <ng-container *ngIf="!loading()">
            <i class="bi {{ confirmIcon }} me-2"></i>{{ confirmButtonText }}
          </ng-container>
          <ng-container *ngIf="loading()">
            <span class="spinner-border spinner-border-sm me-2"></span>{{ buttonLoadingText }}
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>